import { types } from './actions';

const initialState = {
  isFeatureFlagDrawerOpen: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FEATURE_FLAG_DRAWER_OPEN:
      return {
        ...state,
        isFeatureFlagDrawerOpen: true,
      };
    case types.FEATURE_FLAG_DRAWER_CLOSE:
      return {
        ...state,
        isFeatureFlagDrawerOpen: false,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.common.drawers.featureFlagDrawer;

export const getIsFeatureFlagDrawerOpen = (state) =>
  getScope(state).isFeatureFlagDrawerOpen;
